<template lang="pug">
  LayoutDefault
    .page: .container-fluid
      .section: .card: .card--body
        .heading--section Margin Reports
        
        .row.pad_t--15
          .col-xl-4.col-lg-6.col-md-8
            b-form-select(v-model="filterDate", size="sm", @change="FETCH_RECORDS")
              option(v-for="month in enums.monthYear", :value="month.value") {{ month.text }}

        Loading(:isLoading="isDataLoading", type="bar")
          DataTable.mt-4(
            :displaySearch="false", 
            :displayItemsPerPage="false",
            :records="recordsCleaned", 
            :headers="headers", 
            :emptyDisplayMessage="`No records found. You currently do not have any Margin reports for ${ enums.monthYear.find(a => a.value === filterDate).text }.`",
            tableBreak="xsm",
          )
            template(v-slot:slot-for-link="item")
              a.button.button-secondary(
                :href="`${baseAPIURL}/trades/marginaccountfile?file=${item.record.link}&access_token=${jwt}`", 
                target="_blank"
              )
                span.text--size_11.text-uppercase: strong Download
                span.text--size_11.ml-2: i.fas.fa-download

</template>



<script>
  import { mapState } from 'vuex';
  import requestHandlers from '../../mixins/requestHandlers';

  import DataTable from '../../components/DataTable';
  import Loading from '../../components/Loading';

  import * as moment from 'moment';

  export default {
    name: 'tradesMargin',

    mixins: [requestHandlers],

    components: {
      DataTable,
      Loading
    },

    data: () => ({
      baseAPIURL: process.env.VUE_APP_REQUEST_BASE_URL, 

      enums: {
        monthYear: [],
      },

      filterDate: moment().format('YYYY-MM'),

      records: [],

      headers: [
        {
          id: 'date',
          text: 'Report Date',
          type: 'string',
          colWidth: 20,
        },
        {
          id: 'clientCode',
          text: 'Client Code',
          type: 'string',
          colWidth: 20,
        },
        {
          id: 'link',
          text: '',
          type: 'custom_slot',
          colWidth: 30,
        },
      ]

    }),


    computed: {
      ...mapState('auth', [
        'jwt'
      ]),

      selectedMonth() {
        return this.filterDate.split('-')[1];
      },
      selectedYear() {
        return this.filterDate.split('-')[0];
      },

      recordsCleaned() {
        return this.records.map(r => {
          return {
            date: moment(r.reportDate, 'YYMMdd').format('DD MMM YY'),
            link: r.fileLink,
            clientCode: r.clientCode
          };
        })
      }
    },


    methods: {
      GENERATE_MONTH_OPTIONS() {
        let _months = [];

        let currentDate = moment().startOf('day');
        let startDate = moment().subtract(12, 'months').startOf('month');

        while(startDate.add(1, 'months').diff(currentDate) < 0) {
          let _startDate = startDate.clone();

          let _obj = {
            text: _startDate.format('MMMM YYYY'),
            value: _startDate.format('YYYY-MM'),
          }

          _months.push(_obj);
        }

        this.enums.monthYear = _months.reverse();
      },

      async FETCH_RECORDS() {
        this.REQUEST_INIT();

        try {
          let { data: { data: records } } = await this.$axios.get('/trades/marginaccounts', {
            params: {
              year: this.selectedYear,
              month: this.selectedMonth
            }
          })

          this.records = records;

        } catch(error) {
          this.HANDLE_ERROR_GENERIC(error)

        } finally {
          this.REQUEST_FINALLY()

        }
      },
    },

    created() {
      this.GENERATE_MONTH_OPTIONS();
      this.FETCH_RECORDS();
    },
  }
</script>